//wordIcons.ts
export const wordIcons: Record<string, string> = {
  // Arabic words with their icons
  "كتاب": "📖",
  "قلم": "🖊️",
  "مفتاح": "🔑",
  "باب": "🚪",
  "بيت": "🏠",
  "مدرسة": "🏫",
  "مسجد": "🕌",
  "سيارة": "🚗",
  "طائرة": "✈️",
  "قطار": "🚂",
  "تفاحة": "🍎",
  "موز": "🍌",
  "برتقال": "🍊",
  "عنب": "🍇",
  "ماء": "💧",
  "شاي": "🍵",
  "قهوة": "☕",
  "خبز": "🍞",
  "جبن": "🧀",
  "حليب": "🥛",
  "سمك": "🐟",
  "دجاج": "🐔",
  "لحم": "🥩",
  "سكر": "🍬",
  "ملح": "🧂",
  "زيت": "🫒",
  "شمس": "☀️",
  "قمر": "🌙",
  "نجم": "⭐",
  "سحاب": "☁️",
  "مطر": "🌧️",
  "ثلج": "❄️",
  "ريح": "💨",
  "وردة": "🌹",
  "زهرة": "🌸",
  "شجرة": "🌳",
  "نهر": "🏞️",
  "بحر": "🌊",
  "جبل": "⛰️",
  "صحراء": "🏜️",
  "غابة": "🌲",
  "حجر": "🪨",
  "ذهب": "🥇",
  "فضة": "🥈",
  "حديد": "⚙️",
  "نحاس": "🔶",
  "قط": "🐱",
  "كلب": "🐶",
  "حصان": "🐴",
  "ناقة": "🐫",
  "أسد": "🦁",
  "نمر": "🐯",
  "فيل": "🐘",
  "حوت": "🐋",
  "نسر": "🦅",
  "بومة": "🦉",
};

/**
 * Get icon for a word
 */
export const getWordIcon = (word: string): string => {
  // Check if the word exists in the mapping
  if (wordIcons[word]) {
    return wordIcons[word];
  }
  
  // Try to match with case-insensitive
  const lowerWord = word.toLowerCase();
  const matchedKey = Object.keys(wordIcons).find(
    key => key.toLowerCase() === lowerWord
  );
  
  return matchedKey ? wordIcons[matchedKey] : "";
};

/**
 * Check if a word has an icon
 */
export const hasWordIcon = (word: string): boolean => {
  return !!getWordIcon(word);
};

/**
 * Get all words with icons for reference
 */
export const getAllWordsWithIcons = (): { word: string; icon: string }[] => {
  return Object.entries(wordIcons).map(([word, icon]) => ({ word, icon }));
};